module.exports = __webpack_public_path__ + "static/Scores-051f650bff3e237e91b3fd1eb6dac33a.png";